import { BuzzkuriBreadcrumb } from '@components/buzzkuri/shared/uiParts/breadcrumb/BuzzkuriBreadcrumb'
import { ProgramsPathsContext } from '@context/ProgramsPaths/Context'
import { ProgramsListPageContent } from '@type/buzzkuri/programs'
import { Slugs } from '@type/buzzkuri/programs-categor'
import { useRouter } from 'next/router'
import { useContext, useEffect } from 'react'
import { CategoryNavList } from '../../Programs/CategoryNavList'
import { TargetProgramList } from '../ProgramCategory/TargetProgramList'

export const ProgramCross = ({
  pageContent,
  slugs,
}: { pageContent: ProgramsListPageContent } & {
  slugs: Slugs
}): JSX.Element => {
  const { title = '' } = pageContent

  const { init } = useContext(ProgramsPathsContext)
  const router = useRouter()
  useEffect(() => {
    const jaPath = decodeURI(router.asPath).split('/')
    // tag selected -> programs list init
    // ex. ['', 'programs', [tagName]]
    if (jaPath.length === 3) {
      init()
    }
  }, [init, router.asPath])

  return (
    <>
      <div className="">
        <div className="mt-[3.2vw] lg:mt-[2.4vw]">
          <BuzzkuriBreadcrumb
            currentPathName={title.replace(
              'プログラム一覧(対面/オンライン)',
              'プログラム'
            )}
          />
        </div>

        <div className="mt-[13.6vw] lg:mt-[2.7vw] lg:max-w-[62.5vw]">
          <TargetProgramList
            slug={title?.replace('のプログラム一覧(対面/オンライン)', '')}
            heading={title}
            isMajorHeading
            MainHeadingTag="h1"
            {...pageContent}
            {...{ slugs }}
            ProgramHeadingTag="h2"
          />
        </div>

        <div className="mt-[16vw] lg:mt-[6.3vw]">
          <CategoryNavList />
        </div>
      </div>
    </>
  )
}
